module.exports = __webpack_public_path__ + "static/media/BOK.2c83d64f.png";